import { Component, OnInit } from '@angular/core';
import { LogedUser } from '@base/src/app/core/models/logged-user.model';
import { UtilsService } from '@base/src/app/services/utils.service';

@Component({
  selector: 'app-recruitment-config',
  templateUrl: './recruitment.component.html',
  styleUrls: ['./recruitment.component.scss'],
})
export class RecruitmentConfigComponent implements OnInit {
  evaluationList: { id: number; evaluation: string }[] = [];

  readonly STAGES = 'Etapas y fases';
  readonly SCORE = 'Puntajes';

  formSelected = this.STAGES;
  user: LogedUser | undefined;

  constructor(
    private readonly utils: UtilsService,
  ) {}

  ngOnInit(): void {
    this.user = this.utils.getLoggedUser();
  }
}
